export default "__VITE_ASSET__B3n$qkA___"